import styled from "styled-components";

export const ShowMoreButtonContainer = styled.button`
  display: flex;
  padding: 0;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  width: fit-content;
  gap: 8px;
`;

export const ChevronContainer = styled.span`
  display: inline-flex;
  transition: transform 0.5s ease;
  transform: ${(props) => (props.isExpanded ? "rotate(180deg)" : "rotate(0)")};
`;
